var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_506",
    "data-name": "Rectangle 506",
    width: 35.611,
    height: 35.611,
    fill: "none"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_437",
    x: 134,
    y: 92,
    width: 76,
    height: 76,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.42
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_439",
    x: 137,
    y: 95,
    width: 70,
    height: 70,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff5954"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_437-2",
    x: 19,
    y: 92,
    width: 76,
    height: 76,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.42
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_439-2",
    x: 22,
    y: 95,
    width: 70,
    height: 70,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff5954"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-background_desktop"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "background_desktop",
    clipPath: "url(#clip-background_desktop)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    transform: "translate(-213.877 -2361.78)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1460",
    "data-name": "Groupe 1460",
    transform: "translate(0 928.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1754",
    "data-name": "Trac\\xE9 1754",
    d: "M2114.126,1026.886H0V494.22H160.636l279.816,1.541H2114.126Z",
    transform: "translate(0 -494.22)",
    fill: "#d1e5e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1755",
    "data-name": "Trac\\xE9 1755",
    d: "M2114.126,1057.184H0V526.04H2114.126Z",
    transform: "translate(0 -466.243)",
    fill: "#d1e5e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1756",
    "data-name": "Trac\\xE9 1756",
    d: "M2114.126,1041.9H454.96l-307.8-.019H0V509.22H160.636l279.816,1.541H2114.126Z",
    transform: "translate(0 -481.032)",
    fill: "#b4ccc7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1459",
    "data-name": "Groupe 1459",
    transform: "translate(0 239.977)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Ligne_408",
    "data-name": "Ligne 408",
    x2: 2114.126,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 5,
    opacity: 0.13
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_409",
    "data-name": "Ligne 409",
    x2: 2114.126,
    transform: "translate(0 9.546)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 5,
    opacity: 0.3
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1481",
    "data-name": "Groupe 1481",
    transform: "translate(19.751)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1757",
    "data-name": "Trac\\xE9 1757",
    d: "M1067.573,324.116H258.661L104.753,418.49H10.51V19.08H1067.573Z",
    transform: "translate(-10.51 16.776)",
    fill: "#d1e5e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1758",
    "data-name": "Trac\\xE9 1758",
    d: "M1067.573,305.036H258.661L104.753,399.41H10.51V0H1067.573Z",
    transform: "translate(-10.51)",
    fill: "#b4ccc7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1759",
    "data-name": "Trac\\xE9 1759",
    d: "M573.01,324.116h808.912l153.89,94.375h94.262V19.08H573.01Z",
    transform: "translate(484.053 16.776)",
    fill: "#d1e5e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1760",
    "data-name": "Trac\\xE9 1760",
    d: "M563.01,305.036h827.7L1544.6,399.41h94.262V0H563.01Z",
    transform: "translate(475.261)",
    fill: "#b4ccc7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1461",
    "data-name": "Groupe 1461",
    transform: "translate(699.936 0.432)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Ligne_410",
    "data-name": "Ligne 410",
    y2: 304.566,
    transform: "translate(9.546)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 5,
    opacity: 0.13
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_411",
    "data-name": "Ligne 411",
    y2: 304.566,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 5,
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1462",
    "data-name": "Groupe 1462",
    transform: "translate(1404.644 0.432)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Ligne_412",
    "data-name": "Ligne 412",
    y2: 304.566,
    transform: "translate(9.546)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 5,
    opacity: 0.13
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_413",
    "data-name": "Ligne 413",
    y2: 304.566,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 5,
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1465",
    "data-name": "Groupe 1465",
    transform: "translate(2064.816 9.208)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1464",
    "data-name": "Groupe 1464",
    transform: "translate(0 0)",
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_426",
    "data-name": "Ellipse 426",
    cx: 17.796,
    cy: 17.796,
    r: 17.796,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1463",
    "data-name": "Groupe 1463",
    transform: "translate(0 0)",
    opacity: 0.48
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1761",
    "data-name": "Trac\\xE9 1761",
    d: "M17.8,3.758A14.038,14.038,0,1,1,3.758,17.8,14.051,14.051,0,0,1,17.8,3.758M17.8,0a17.8,17.8,0,1,0,17.8,17.8A17.8,17.8,0,0,0,17.8,0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1468",
    "data-name": "Groupe 1468",
    transform: "translate(1433.998 9.208)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1467",
    "data-name": "Groupe 1467",
    transform: "translate(0 0)",
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_427",
    "data-name": "Ellipse 427",
    cx: 17.796,
    cy: 17.796,
    r: 17.796,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1466",
    "data-name": "Groupe 1466",
    transform: "translate(0 0)",
    opacity: 0.48
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1762",
    "data-name": "Trac\\xE9 1762",
    d: "M17.8,3.758A14.038,14.038,0,1,1,3.758,17.8,14.051,14.051,0,0,1,17.8,3.758M17.8,0a17.8,17.8,0,1,0,17.8,17.8A17.8,17.8,0,0,0,17.8,0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1471",
    "data-name": "Groupe 1471",
    transform: "translate(1351.462 9.208)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1470",
    "data-name": "Groupe 1470",
    transform: "translate(0 0)",
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_428",
    "data-name": "Ellipse 428",
    cx: 17.796,
    cy: 17.796,
    r: 17.796,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1469",
    "data-name": "Groupe 1469",
    transform: "translate(0 0)",
    opacity: 0.48
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1763",
    "data-name": "Trac\\xE9 1763",
    d: "M17.8,3.758A14.038,14.038,0,1,1,3.758,17.8,14.051,14.051,0,0,1,17.8,3.758M17.8,0a17.8,17.8,0,1,0,17.8,17.8A17.8,17.8,0,0,0,17.8,0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1474",
    "data-name": "Groupe 1474",
    transform: "translate(728.65 9.208)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1473",
    "data-name": "Groupe 1473",
    transform: "translate(0 0)",
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_429",
    "data-name": "Ellipse 429",
    cx: 17.796,
    cy: 17.796,
    r: 17.796,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1472",
    "data-name": "Groupe 1472",
    transform: "translate(0 0)",
    opacity: 0.48
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1764",
    "data-name": "Trac\\xE9 1764",
    d: "M17.8,3.758A14.038,14.038,0,1,1,3.758,17.8,14.051,14.051,0,0,1,17.8,3.758M17.8,0a17.8,17.8,0,1,0,17.8,17.8A17.8,17.8,0,0,0,17.8,0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1477",
    "data-name": "Groupe 1477",
    transform: "translate(647.994 9.208)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1476",
    "data-name": "Groupe 1476",
    transform: "translate(0 0)",
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_430",
    "data-name": "Ellipse 430",
    cx: 17.796,
    cy: 17.796,
    r: 17.796,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1475",
    "data-name": "Groupe 1475",
    transform: "translate(0 0)",
    opacity: 0.48
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1765",
    "data-name": "Trac\\xE9 1765",
    d: "M17.8,3.758A14.038,14.038,0,1,1,3.758,17.8,14.051,14.051,0,0,1,17.8,3.758M17.8,0a17.8,17.8,0,1,0,17.8,17.8A17.8,17.8,0,0,0,17.8,0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1480",
    "data-name": "Groupe 1480",
    transform: "translate(11.069 9.208)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1479",
    "data-name": "Groupe 1479",
    transform: "translate(0 0)",
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_431",
    "data-name": "Ellipse 431",
    cx: 17.796,
    cy: 17.796,
    r: 17.796,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1478",
    "data-name": "Groupe 1478",
    transform: "translate(0 0)",
    opacity: 0.48
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1766",
    "data-name": "Trac\\xE9 1766",
    d: "M17.8,3.758A14.038,14.038,0,1,1,3.758,17.8,14.051,14.051,0,0,1,17.8,3.758M17.8,0a17.8,17.8,0,1,0,17.8,17.8A17.8,17.8,0,0,0,17.8,0Z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1497",
    "data-name": "Groupe 1497",
    transform: "translate(116.815 2154.886)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1767",
    "data-name": "Trac\\xE9 1767",
    d: "M1068.073,1227.985H229.094L75.2,1146.69H11.01v441.58H1068.073Z",
    transform: "translate(-10.07 -1146.69)",
    fill: "#d1e5e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1768",
    "data-name": "Trac\\xE9 1768",
    d: "M1068.073,1244.425H210.3l-153.89-81.3H11.01V2552.91H1068.073Z",
    transform: "translate(-10.07 -1132.236)",
    fill: "#b4ccc7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1769",
    "data-name": "Trac\\xE9 1769",
    d: "M572.5,1227.985h838.979l153.89-81.3h64.194v441.58H572.5Z",
    transform: "translate(483.605 -1146.69)",
    fill: "#d1e5e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1770",
    "data-name": "Trac\\xE9 1770",
    d: "M562.5,1244.425h876.564l153.908-81.3h45.383V2552.91H562.5Z",
    transform: "translate(474.813 -1132.236)",
    fill: "#b4ccc7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1482",
    "data-name": "Groupe 1482",
    transform: "translate(0 652.016)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Ligne_414",
    "data-name": "Ligne 414",
    x2: 2114.126,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 5,
    opacity: 0.13
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_415",
    "data-name": "Ligne 415",
    x2: 2114.126,
    transform: "translate(0 9.546)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 5,
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1483",
    "data-name": "Groupe 1483",
    transform: "translate(1047.554 341.042)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Ligne_416",
    "data-name": "Ligne 416",
    y2: 1079.633,
    transform: "translate(9.546)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 5,
    opacity: 0.13
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_417",
    "data-name": "Ligne 417",
    y2: 1079.633,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 5,
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1486",
    "data-name": "Groupe 1486",
    transform: "translate(2038.506 247.024)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1485",
    "data-name": "Groupe 1485",
    transform: "translate(0 0)",
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_432",
    "data-name": "Ellipse 432",
    cx: 17.796,
    cy: 17.796,
    r: 17.796,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1484",
    "data-name": "Groupe 1484",
    transform: "translate(0 0)",
    opacity: 0.48
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1771",
    "data-name": "Trac\\xE9 1771",
    d: "M17.8,3.758A14.038,14.038,0,1,1,3.758,17.8,14.051,14.051,0,0,1,17.8,3.758M17.8,0a17.8,17.8,0,1,0,17.8,17.8A17.8,17.8,0,0,0,17.8,0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1489",
    "data-name": "Groupe 1489",
    transform: "translate(41.136 247.024)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1488",
    "data-name": "Groupe 1488",
    transform: "translate(0 0)",
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_433",
    "data-name": "Ellipse 433",
    cx: 17.796,
    cy: 17.796,
    r: 17.796,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1487",
    "data-name": "Groupe 1487",
    transform: "translate(0 0)",
    opacity: 0.48
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1772",
    "data-name": "Trac\\xE9 1772",
    d: "M17.8,3.758A14.038,14.038,0,1,1,3.758,17.8,14.051,14.051,0,0,1,17.8,3.758M17.8,0a17.8,17.8,0,1,0,17.8,17.8A17.8,17.8,0,0,0,17.8,0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1492",
    "data-name": "Groupe 1492",
    transform: "translate(2038.506 698.695)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1491",
    "data-name": "Groupe 1491",
    transform: "translate(0 0)",
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_434",
    "data-name": "Ellipse 434",
    cx: 17.796,
    cy: 17.796,
    r: 17.796,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1490",
    "data-name": "Groupe 1490",
    transform: "translate(0 0)",
    opacity: 0.48
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1773",
    "data-name": "Trac\\xE9 1773",
    d: "M17.8,3.758A14.038,14.038,0,1,1,3.758,17.8,14.051,14.051,0,0,1,17.8,3.758M17.8,0a17.8,17.8,0,1,0,17.8,17.8A17.8,17.8,0,0,0,17.8,0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1495",
    "data-name": "Groupe 1495",
    transform: "translate(41.136 698.695)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1494",
    "data-name": "Groupe 1494",
    transform: "translate(0 0)",
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_435",
    "data-name": "Ellipse 435",
    cx: 17.796,
    cy: 17.796,
    r: 17.796,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1493",
    "data-name": "Groupe 1493",
    transform: "translate(0 0)",
    opacity: 0.48
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1774",
    "data-name": "Trac\\xE9 1774",
    d: "M17.8,3.758A14.038,14.038,0,1,1,3.758,17.8,14.051,14.051,0,0,1,17.8,3.758M17.8,0a17.8,17.8,0,1,0,17.8,17.8A17.8,17.8,0,0,0,17.8,0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1496",
    "data-name": "Groupe 1496",
    transform: "translate(0 326.759)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Ligne_418",
    "data-name": "Ligne 418",
    x2: 2114.126,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 5,
    opacity: 0.13
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_419",
    "data-name": "Ligne 419",
    x2: 2114.126,
    transform: "translate(0 9.547)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 5,
    opacity: 0.3
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_519",
    "data-name": "Rectangle 519",
    transform: "translate(-59)",
    fill: "#a6beb9",
    stroke: "#9db2ad",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("rect", {
    width: 438,
    height: 835,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 434,
    height: 831,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_524",
    "data-name": "Rectangle 524",
    transform: "translate(1557)",
    fill: "#a6beb9",
    stroke: "#9db2ad",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("rect", {
    width: 438,
    height: 835,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 434,
    height: 831,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_518",
    "data-name": "Rectangle 518",
    transform: "translate(-87)",
    fill: "#b4ccc7",
    stroke: "#9db2ad",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("rect", {
    width: 421,
    height: 772,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 417,
    height: 768,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_525",
    "data-name": "Rectangle 525",
    transform: "translate(1602)",
    fill: "#b4ccc7",
    stroke: "#9db2ad",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("rect", {
    width: 421,
    height: 772,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 417,
    height: 768,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_420",
    "data-name": "Ligne 420",
    x1: 38,
    y1: 55,
    transform: "translate(334.5 772.5)",
    fill: "none",
    stroke: "#9db2ad",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1498",
    "data-name": "Groupe 1498"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_520",
    "data-name": "Rectangle 520",
    transform: "translate(-81 54)",
    fill: "#b4ccc7",
    stroke: "#9db2ad",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("rect", {
    width: 343,
    height: 146,
    rx: 34,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 339,
    height: 142,
    rx: 32,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_421",
    "data-name": "Ligne 421",
    x2: 248,
    transform: "translate(-14.5 197.5)",
    fill: "none",
    stroke: "#cbdcd8",
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1502",
    "data-name": "Groupe 1502",
    transform: "translate(1749)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_520-2",
    "data-name": "Rectangle 520",
    transform: "translate(-81 54)",
    fill: "#647f9f",
    stroke: "#9db2ad",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("rect", {
    width: 343,
    height: 620,
    rx: 34,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 339,
    height: 616,
    rx: 32,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_526",
    "data-name": "Rectangle 526",
    width: 395,
    height: 550,
    rx: 34,
    transform: "translate(-53 89)",
    fill: "#4b9cff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1503",
    "data-name": "Groupe 1503",
    transform: "translate(-53.004 88.777)",
    opacity: 0.57
  }, /*#__PURE__*/React.createElement("line", {
    id: "Ligne_423",
    "data-name": "Ligne 423",
    y2: 550.602,
    transform: "translate(80.504 0)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1776",
    "data-name": "Trac\\xE9 1776",
    d: "M0,0V510.5",
    transform: "translate(510.504 71.844) rotate(90)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1777",
    "data-name": "Trac\\xE9 1777",
    d: "M0,0V510.5",
    transform: "translate(510.504 167.47) rotate(90)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1778",
    "data-name": "Trac\\xE9 1778",
    d: "M0,0V510.5",
    transform: "translate(510.504 266.127) rotate(90)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1779",
    "data-name": "Trac\\xE9 1779",
    d: "M0,0V510.5",
    transform: "translate(510.504 364.783) rotate(90)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1780",
    "data-name": "Trac\\xE9 1780",
    d: "M0,0V510.5",
    transform: "translate(510.504 459.602) rotate(90)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_424",
    "data-name": "Ligne 424",
    y2: 550.602,
    transform: "translate(178.504 0)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_421-2",
    "data-name": "Ligne 421",
    x2: 248,
    transform: "translate(-14.5 671.208)",
    fill: "none",
    stroke: "#cbdcd8",
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1501",
    "data-name": "Groupe 1501",
    transform: "translate(0 186)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_520-3",
    "data-name": "Rectangle 520",
    transform: "translate(-81 54)",
    fill: "#b4ccc7",
    stroke: "#9db2ad",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("rect", {
    width: 261,
    height: 449,
    rx: 34,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 257,
    height: 445,
    rx: 32,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_421-3",
    "data-name": "Ligne 421",
    x2: 229.5,
    transform: "translate(-81 500.385)",
    fill: "none",
    stroke: "#cbdcd8",
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1499",
    "data-name": "Groupe 1499"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_436",
    "data-name": "Ellipse 436",
    transform: "translate(134 89)",
    fill: "#afc7c2",
    stroke: "#9db2ad",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 38,
    r: 38,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 38,
    r: 36,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Ellipse_437)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_437-3",
    "data-name": "Ellipse 437",
    cx: 29,
    cy: 29,
    r: 29,
    transform: "translate(143 98)",
    fill: "#ee332d"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_438",
    "data-name": "Ellipse 438",
    cx: 13,
    cy: 13,
    r: 13,
    transform: "translate(153 106)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Ellipse_439)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_439-3",
    "data-name": "Ellipse 439",
    cx: 26,
    cy: 26,
    r: 26,
    transform: "translate(146 101)",
    fill: "#fff",
    opacity: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1500",
    "data-name": "Groupe 1500",
    transform: "translate(-115)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_436-2",
    "data-name": "Ellipse 436",
    transform: "translate(134 89)",
    fill: "#afc7c2",
    stroke: "#9db2ad",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 38,
    r: 38,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 38,
    r: 36,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 115, 0)",
    filter: "url(#Ellipse_437-2)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_437-4",
    "data-name": "Ellipse 437",
    cx: 29,
    cy: 29,
    r: 29,
    transform: "translate(28 98)",
    fill: "#329e51"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_438-2",
    "data-name": "Ellipse 438",
    cx: 13,
    cy: 13,
    r: 13,
    transform: "translate(153 106)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 115, 0)",
    filter: "url(#Ellipse_439-2)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_439-4",
    "data-name": "Ellipse 439",
    cx: 26,
    cy: 26,
    r: 26,
    transform: "translate(31 101)",
    fill: "#fff",
    opacity: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_521",
    "data-name": "Rectangle 521",
    transform: "translate(-23 274)",
    fill: "#818586",
    stroke: "#656565",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 373,
    rx: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 61,
    height: 369,
    rx: 6,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_522",
    "data-name": "Rectangle 522",
    width: 295,
    height: 63,
    rx: 16,
    transform: "translate(-163 551)",
    fill: "#555"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_523",
    "data-name": "Rectangle 523",
    width: 295,
    height: 59,
    rx: 16,
    transform: "translate(-157 570)",
    fill: "#555",
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1775",
    "data-name": "Trac\\xE9 1775",
    d: "M0,0H229.5",
    transform: "translate(-194.75 645)",
    fill: "none",
    stroke: "#bfbfbf",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_422",
    "data-name": "Ligne 422",
    y1: 55,
    x2: 38,
    transform: "translate(1563.5 772.5)",
    fill: "none",
    stroke: "#9db2ad",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_425",
    "data-name": "Ligne 425",
    x2: 357,
    y2: 0.885,
    transform: "translate(-28.5 765.5)",
    fill: "none",
    stroke: "#cbdcd8",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_426",
    "data-name": "Ligne 426",
    x2: 357,
    y2: 0.885,
    transform: "translate(1607 765.5)",
    fill: "none",
    stroke: "#cbdcd8",
    strokeWidth: 5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundDesktop);
export default __webpack_public_path__ + "static/media/background_desktop.01f672929aa12dd2a399f2cdb3988e12.svg";
export { ForwardRef as ReactComponent };